const lightPurple = "#8D6FFC";
const purple = "#48406A";
const blue = "#267AFF";
const turquoise = "#0FB4B6";
const green = "#11a00d"; // rgb(17, 160, 13)
const purpleMedium = "#b724b7";
const yellow = "#C0A60D";
const red = "#eb445a";
const gray = "#F2F2F2";
const lightGray = "#6F6F6F";
const mediumGray = "#424242";
const darkGray = "#2E2E2E";
const dark = "#1D1D1D";
const white = "#FFFFFF";
const lightGreen = "#90EE90";
const lightDark = "#333333a8";
const orange = "#FF6105";
const orangeLight = "#fc7753";
const amber = "#FFBF00";
const darkYellow = "#919b20";

const lightPurpleRGBA = "rgba(141, 111, 252, 0.2)";
const purpleRGBA = "rgba(72, 64, 106, 0.2)";
const blueRGBA = "rgba(38, 122, 255, 0.2)";
const turquoiseRGBA = "rgba(15, 180, 182, 0.2)";
const greenRGBA = "rgba(76, 134, 15, 0.2)";
const yellowRGBA = "rgba(192, 166, 13, 0.2)";
const redRGBA = "rgba(255, 0, 0, 0.2)";
const grayRGBA = "rgba(242, 242, 242, 0.2)";
const lightGrayRGBA = "rgba(111, 111, 111, 0.2)";
const mediumGrayRGBA = "rgba(66, 66, 66, 0.2)";
const darkGrayRGBA = "rgba(46, 46, 46, 0.2)";
const darkRGBA = "rgba(29, 29, 29, 0.2)";
const whiteRGBA = "rgba(255, 255, 255, 0.2)";
const lightGreenRGBA = "rgba(144, 238, 144, 0.2)";
const lightDarkRGBA = "rgba(51, 51, 51, 0.2)";

export {
  lightPurple,
  purple,
  purpleMedium,
  blue,
  turquoise,
  green,
  yellow,
  red,
  gray,
  lightGray,
  mediumGray,
  darkGray,
  dark,
  white,
  lightGreen,
  lightDark,
  orange,
  orangeLight,
  lightPurpleRGBA,
  purpleRGBA,
  blueRGBA,
  turquoiseRGBA,
  greenRGBA,
  yellowRGBA,
  redRGBA,
  grayRGBA,
  lightGrayRGBA,
  mediumGrayRGBA,
  darkGrayRGBA,
  darkRGBA,
  whiteRGBA,
  lightGreenRGBA,
  lightDarkRGBA,
  amber,
  darkYellow,
};
